import { css } from 'styled-components';
const BarlowSemiCondensedFontFaces = css `

    /* Barlow Condensed - Normal */
    @font-face {
        font-family: 'Barlow SemiCondensed';
        src: url('/fonts/BarlowSemiCondensed-Regular.ttf') format('truetype');
        font-weight: normal;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: 'Barlow SemiCondensed';
        src: url('/fonts/BarlowSemiCondensed-SemiBold.ttf') format('truetype');
        font-weight: 600;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: 'Barlow SemiCondensed';
        src: url('/fonts/BarlowSemiCondensed-Bold.ttf') format('truetype');
        font-weight: Bold;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: 'Barlow SemiCondensed';
        src: url('/fonts/BarlowSemiCondensed-ExtraBold.ttf') format('truetype');
        font-weight: 800;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: 'Barlow SemiCondensed';
        src: url('/fonts/BarlowSemiCondensed-Medium.ttf') format('truetype');
        font-weight: 500;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: 'Barlow SemiCondensed';
        src: url('/fonts/BarlowSemiCondensed-Light.ttf') format('truetype');
        font-weight: 200;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: 'Barlow Condensed';
        src: url('/fonts/BarlowSemiCondensed-ExtraLight.ttf') format('truetype');
        font-weight: lighter;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: 'Barlow SemiCondensed';
        src: url('/fonts/BarlowSemiCondensed-Thin.ttf') format('truetype');
        font-weight: 100;
        font-style: normal;
        font-display: swap;
    }

    /* Barlow Condensed - Italic */

    @font-face {
        font-family: 'Barlow SemiCondensed';
        src: url('/fonts/BarlowSemiCondensed-Italic.ttf') format('truetype');
        font-weight: normal;
        font-style: italic;
        font-display: swap;
    }

    @font-face {
        font-family: 'Barlow SemiCondensed';
        src: url('/fonts/BarlowSemiCondensed-SemiBoldItalic.ttf') format('truetype');
        font-weight: 600;
        font-style: italic;
        font-display: swap;
    }

    @font-face {
        font-family: 'Barlow SemiCondensed';
        src: url('/fonts/BarlowSemiCondensed-BoldItalic.ttf') format('truetype');
        font-weight: Bold;
        font-style: italic;
        font-display: swap;
    }

    @font-face {
        font-family: 'Barlow SemiCondensed';
        src: url('/fonts/BarlowSemiCondensed-ExtraBoldItalic.ttf') format('truetype');
        font-weight: 800;
        font-style: italic;
        font-display: swap;
    }

    @font-face {
        font-family: 'Barlow SemiCondensed';
        src: url('/fonts/BarlowSemiCondensed-MediumItalic.ttf') format('truetype');
        font-weight: 500;
        font-style: italic;
        font-display: swap;
    }

    @font-face {
        font-family: 'Barlow SemiCondensed';
        src: url('/fonts/BarlowSemiCondensed-LightItalic.ttf') format('truetype');
        font-weight: 200;
        font-style: italic;
        font-display: swap;
    }

    @font-face {
        font-family: 'Barlow SemiCondensed';
        src: url('/fonts/BarlowSemiCondensed-ExtraLightItalic.ttf') format('truetype');
        font-weight: lighter;
        font-style: italic;
        font-display: swap;
    }

    @font-face {
        font-family: 'Barlow SemiCondensed';
        src: url('/fonts/BarlowSemiCondensed-ThinItalic.ttf') format('truetype');
        font-weight: 100;
        font-style: italic;
        font-display: swap;
    }
`;
export default BarlowSemiCondensedFontFaces;
//# sourceMappingURL=BarlowSemiCondensed.js.map